// Client gate for recording a project view: signed-in agents only, once per project per page mount.
export type ProjectViewClientState = {
  projectId: unknown;
  token: string | null | undefined;
  role: string | null | undefined;
  isImpersonating: boolean;
  alreadyRecorded: ReadonlySet<string>;
};

export const projectViewToRecord = (s: ProjectViewClientState): string | null => {
  const id = typeof s.projectId === 'string' || typeof s.projectId === 'number' ? String(s.projectId).trim() : '';
  if (!id || !s.token || s.role !== 'AGENT' || s.isImpersonating || s.alreadyRecorded.has(id)) return null;
  return id;
};
